// @ vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');

// @components
const WizardError = require('components/commons/wizardError/wizardError');

// @utilities
const { recordProcess } = require('utilities/tagging');

//@constants
const {
    PROC_DELETE_SHIPPING_ADDRESS,
    PROC_FAIL,
} = require('utilities/tagging');

class MyProfileRemoveShippingAddressError extends React.Component {

    componentDidMount() {
        recordProcess(PROC_DELETE_SHIPPING_ADDRESS, PROC_FAIL);
    }

    render() {
        const { immVariables } = this.props;
        const goBackButton = {
            label: (
                <FormattedText
                    value="profileRemoveShippingAddress-profileRemoveShippingAddress_successBackButtonText"
                />
            ),
            url: '/myprofile/edit'
        };

        let errorMessage = formatText('profileRemoveShippingAddress-profileRemoveShippingAddress_errorTitle');

        return (
            <WizardError
                errorMessage={errorMessage}
                mainButton={goBackButton}
            >
                <FormattedText
                    injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                    value="profileRemoveShippingAddress-profileRemoveShippingAddress_errorSubtitle"
                />
            </WizardError>
        );
    }
}

MyProfileRemoveShippingAddressError.propTypes = {
    immVariables: PropTypes.object.isRequired,
};

module.exports = MyProfileRemoveShippingAddressError;
